module.exports = __webpack_public_path__ + "static/miniature1-47bf179a2b2026491769c30a420d0ed6.jpg";